import React from 'react'
import { getImages } from '../../Const'
import DefineStyle from './DefineStyle'
import { Formik, Form, Field } from 'formik';

const ListFormField = ({
    fieldName, values, handleDefineStyle,
    visibleBox, setFieldStyle, closeDefineStyle, setFieldValue, textLabel, hideInputField
}) => {
    return (
        <>
            <li>
                <div className="d-flex align-items-center">
                    <div>
                            <label className='xs-title font-12' htmlFor={fieldName}>{textLabel}</label>
                    </div>
                    <div className="ms-auto">
                        {!hideInputField &&
                            <Field
                                type="text"
                                name={`${fieldName}.value`}
                                className="form-control"
                                disabled={!values[fieldName]?.enabled}
                            />
                        }
                    </div>
                    <div>
                        <div className="position-relative ms-2">
                            {!hideInputField &&
                                <button type="button" className="ab-move-btn" onClick={() => handleDefineStyle(fieldName)}>
                                    <img src={getImages('bars.png')} />
                                </button>
                            }
                            {visibleBox === fieldName && (
                                <div className="edit-box define-style-box">
                                    <DefineStyle
                                        close={closeDefineStyle}
                                        fieldName={fieldName}
                                        currentStyle={{
                                            fontSize: values[fieldName]?.fontSize,
                                            color: values[fieldName]?.color,
                                        }}
                                        setFieldStyle={setFieldStyle}
                                        setFieldValue={setFieldValue}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </li>
        </>
    )
}

export default ListFormField